import React from 'react';
import { RefreshCw, Anchor } from 'lucide-react';
import { Button } from './UIElements';

const EmbarcacionesSection = ({
  embarcacionesIngresadas,
  cargandoEmbarcaciones,
  onObtenerCantidad
}) => {
  return (
    <div className="bg-verde-esmeralda bg-opacity-10 rounded-xl p-6 shadow-lg">
      <h2 className="text-2xl font-semibold mb-4 flex items-center text-verde-esmeralda">
        <Anchor className="mr-2" /> Registro de Embarcaciones
      </h2>
      <div className="flex items-center space-x-4">
        <Button
          onClick={onObtenerCantidad}
          disabled={cargandoEmbarcaciones}
          className="px-6 py-3 bg-verde-esmeralda hover:bg-emerald-600 text-blanco-puro rounded-lg font-medium flex items-center flex-grow"
        >
          {cargandoEmbarcaciones ? (
            <RefreshCw className="mr-2 inline-block animate-spin" />
          ) : (
            <RefreshCw className="mr-2 inline-block" />
          )}
          Obtener cantidad
        </Button>
        <div className="text-4xl font-bold text-verde-esmeralda min-w-[3ch] text-center">
          {embarcacionesIngresadas !== null ? embarcacionesIngresadas : "-"}
        </div>
      </div>
    </div>
  );
};

export default EmbarcacionesSection;